
import {BifrostBackendNestApi} from "../gateways/BifrostBackendApi";

const UserNotificationsProvider = Object.freeze({
	async getNotifications(tenantId, token) {
		return (await BifrostBackendNestApi.get(`/user-notifications?tenantId=${tenantId}`, {headers: {AuthorizationIdp: token}})).data;
	},
	async updateIsRead(tenantId, token, id, data) {
		await BifrostBackendNestApi.patch(`/user-notifications/${encodeURIComponent(id)}?tenantId=${tenantId}`, data, {headers: {AuthorizationIdp: token}});
	},
	async create(tenantId, token, data) {
		await BifrostBackendNestApi.post(`/user-notifications?tenantId=${tenantId}`, data, {headers: {AuthorizationIdp: token}});
	},
	async getLast(tenantId, token, source) {
		return (await BifrostBackendNestApi.get(`/user-notifications/last?source=${source}`, {
			headers: {AuthorizationIdp: token}
		})).data;
	}
});

export default UserNotificationsProvider;
